import { api } from "@/lib/api";

// Google blocks its sign-in page inside iframes (403), so open it top-level.
export async function openGoogleAuth() {
  const framed = window.self !== window.top;
  const tab = framed ? window.open("", "_blank") : null;
  try {
    const { data } = await api.get("/google-ads/oauth/start");
    if (tab) tab.location.href = data.url;
    else if (framed) window.top.location.href = data.url;
    else window.location.href = data.url;
  } catch (e) {
    if (tab) tab.close();
    throw e;
  }
}
